import * as Yup from "yup";

export function initialValues(assistance) {
  return {
    title: assistance?.title || "",
    path: assistance?.path || "",
    content: assistance?.content || "",
    miniature: assistance?.miniature || "",
    // Cerrado por defecto. Una asistencia que ya existe y no tiene el campo se
    // edita como NO publica, que es lo que es desde el 2026-08-10.
    isPublic: assistance?.isPublic === true,
    file: null,
  };
}

export function validationSchema() {
  return Yup.object({
    title: Yup.string().required(true),
    path: Yup.string().required(true),
    content: Yup.string().required(true),
    miniature: Yup.string().required(true),
  });
}
